const cardItems = [
  {
    title: '热血江湖: 终章之战',
    desc: '主角团迎来最终决战，所有伏笔悉数回收，热血与泪水交织的史诗终章',
    tag: '热血',
    img: 'https://readdy.ai/api/search-image?query=A%20dramatic%20manga%20illustration%20of%20an%20epic%20final%20battle%20scene%20with%20warm%20coral%20and%20golden%20sunset%20tones%2C%20dynamic%20character%20poses%20with%20flowing%20energy%2C%20dramatic%20lighting%20and%20ink%20splash%20effects%2C%20powerful%20emotional%20atmosphere&width=800&height=600&seq=card-comic-01&orientation=landscape',
  },
  {
    title: '异界幻想: 元素觉醒',
    desc: '主角解锁第六元素之力，全新能力带来前所未有的战斗体验',
    tag: '奇幻',
    img: 'https://readdy.ai/api/search-image?query=A%20magical%20fantasy%20manga%20illustration%20with%20warm%20amber%20and%20golden%20tones%2C%20elemental%20energy%20swirling%20around%20a%20character%2C%20floating%20crystals%20and%20magical%20runes%2C%20epic%20atmospheric%20lighting%2C%20vibrant%20warm%20color%20palette&width=800&height=600&seq=card-comic-02&orientation=landscape',
  },
  {
    title: '甜蜜陷阱: 告白进行时',
    desc: '冰山校草终于主动出击，浪漫告白场景甜到让人心跳加速',
    tag: '恋爱',
    img: 'https://readdy.ai/api/search-image?query=A%20sweet%20romantic%20manga%20illustration%20with%20soft%20pink%20and%20peach%20tones%2C%20cherry%20blossoms%20falling%20in%20a%20school%20courtyard%2C%20two%20characters%20sharing%20an%20intimate%20moment%2C%20warm%20golden%20hour%20sunlight%2C%20dreamy%20atmosphere&width=800&height=600&seq=card-comic-03&orientation=landscape',
  },
  {
    title: '暗夜追踪: 真相浮现',
    desc: '凶手身份终于揭晓，出人意料的身份反转让所有读者震惊',
    tag: '悬疑',
    img: 'https://readdy.ai/api/search-image?query=A%20mysterious%20suspenseful%20manga%20illustration%20with%20deep%20amber%20and%20shadow%20tones%2C%20a%20dimly%20lit%20room%20with%20evidence%20board%2C%20dramatic%20lighting%20with%20sharp%20shadows%2C%20noir%20atmosphere%20with%20warm%20and%20dark%20contrast&width=800&height=600&seq=card-comic-04&orientation=landscape',
  },
  {
    title: '都市传说: 画中世界',
    desc: '主角进入画中的诡异世界，超乎想象的视觉震撼体验',
    tag: '惊悚',
    img: 'https://readdy.ai/api/search-image?query=A%20surreal%20horror%20manga%20illustration%20with%20warm%20coral%20and%20deep%20shadow%20tones%2C%20a%20character%20stepping%20into%20a%20painting%20portal%2C%20twisted%20reality%20effects%2C%20atmospheric%20lighting%20with%20golden%20highlights%2C%20eerie%20beautiful%20composition&width=800&height=600&seq=card-comic-05&orientation=landscape',
  },
  {
    title: '古风奇缘: 千年之约',
    desc: '穿越千年的约定，前世今生的虐恋纠葛催人泪下',
    tag: '古风',
    img: 'https://readdy.ai/api/search-image?query=A%20beautiful%20classical%20Chinese%20style%20manga%20illustration%20with%20warm%20sepia%20and%20golden%20tones%2C%20ancient%20temple%20in%20misty%20mountains%2C%20two%20figures%20in%20traditional%20robes%2C%20falling%20cherry%20blossoms%2C%20ethereal%20atmospheric%20lighting&width=800&height=600&seq=card-comic-06&orientation=landscape',
  },
  {
    title: '末世生存: 希望之城',
    desc: '幸存者们终于找到传说中的安全区，但城内隐藏着更大危机',
    tag: '科幻',
    img: 'https://readdy.ai/api/search-image?query=A%20post%20apocalyptic%20manga%20illustration%20with%20warm%20amber%20and%20rust%20tones%2C%20a%20fortified%20city%20in%20a%20wasteland%20at%20sunset%2C%20survivors%20approaching%20the%20gates%2C%20dramatic%20sky%20with%20golden%20clouds%2C%20hopeful%20atmosphere&width=800&height=600&seq=card-comic-07&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center mb-10">
          精彩推荐
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {cardItems.map((item, i) => (
            <div
              key={i}
              className={`group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 cursor-pointer ${
                i === 0 ? 'sm:col-span-2 lg:col-span-2 lg:row-span-2' : ''
              }`}
            >
              <div className={`${i === 0 ? 'aspect-[2/1]' : 'aspect-[4/3]'} overflow-hidden`}>
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 rounded-md bg-accent-100 text-accent-700 text-xs font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <h3 className="text-sm md:text-base font-medium text-foreground-900 mb-1.5 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}